import type { LeagueSummary, Schemas } from "@softmax/observatory-client/types";
import type { WatchLeagueState } from "./watch";

export const watchLeagueCookie = "watch_league_id";

/** Initial league data. Missing reads stay null so clients can load them independently. */
export type WatchTheaterSeed = {
  generatedAt: number;
  leagues: LeagueSummary[] | null;
  state: WatchLeagueState | null;
  stored?: string | null;
  /** Null only for reads made without viewer credentials. */
  viewer: Schemas["WhoAmIResponse"] | null;
  /** Public Watch discovery filters its catalog; game-specific corpora remain available. */
  hideBrowseHidden: boolean;
};
